import { createRoot, createSignal } from 'solid-js';

export const DND_TYPE = 'application/x-bsync-ids';

/** Ids currently being dragged (null when no drag is in progress). */
export const dnd = createRoot(() => {
  const [dragging, setDragging] = createSignal<string[] | null>(null);
  return { dragging, setDragging };
});

export function startDrag(e: DragEvent, ids: string[]) {
  e.dataTransfer?.setData(DND_TYPE, JSON.stringify(ids));
  e.dataTransfer?.setData('text/plain', `${ids.length} item${ids.length === 1 ? '' : 's'}`);
  if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move';
  dnd.setDragging(ids);
}

export function endDrag() {
  dnd.setDragging(null);
}

export function draggedIds(e: DragEvent): string[] | null {
  const raw = e.dataTransfer?.getData(DND_TYPE);
  if (raw) {
    try {
      return JSON.parse(raw) as string[];
    } catch {
      return null;
    }
  }
  return dnd.dragging();
}
